import {Component} from '@angular/core';
import {Router} from '@angular/router';
import { APP_ROUTES } from 'src/app/app-routing.const';

@Component({
    selector: 'app-password-recovery-confirmation',
    templateUrl: './password-recovery-confirmation.component.html',
    styleUrls: ['./password-recovery-confirmation.component.scss'],
    standalone: false
})
export class PasswordRecoveryConfirmationComponent {

  constructor(private router: Router) {}

  goToLogin() {
    this.router.navigate([APP_ROUTES.AUTH.LOGIN]);
  }
}
